import { useCallback, useEffect, useState } from 'react';
import { ColumnSettings } from 'wisestep-api';
import { FieldOption } from 'wisestep-base';

import { useNotificationStore } from '../../../utils/NotificationStore';
import {
  fetchColumnSettings,
  saveColumnSettingsToDB,
} from '../../clientListingPage/helper/ClientListingHelper';
import { defaultCommColumnSettings } from '../utils/communicationUtils';

export const useTableColumnSettings = (tableKey: ColumnSettings) => {
  const setNotification = useNotificationStore((state) => state.setNotification);
  const [columnOptions, setColumnOptions] = useState<FieldOption[]>(() =>
    defaultCommColumnSettings(tableKey)
  );

  useEffect(() => {
    const loadAndMergeSettings = async () => {
      if (!tableKey) {
        console.error('No table key found for the given page type and communication type');
        return;
      }
      const res = await fetchColumnSettings(tableKey, ['type']);
      setColumnOptions(res ?? defaultCommColumnSettings(tableKey));
    };

    loadAndMergeSettings();
  }, [tableKey]);

  const handleColumnSettingsChange = useCallback(
    (data: FieldOption[]) => {
      if (!tableKey) {
        console.error('No table key found for the given page type and communication type');
        return;
      }
      saveColumnSettingsToDB(data, tableKey, setNotification);
      setColumnOptions(data);
    },
    [setNotification, tableKey]
  );

  return { columnOptions, handleColumnSettingsChange };
};
